import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';
import './YouthSummitSubPages.css';
import heroImg from '../../assets/YOCILAB Webiste photos/YOCILAB YOuth Summit/DSC_4561.jpg';
import img2 from '../../assets/YOCILAB Webiste photos/YOCILAB YOuth Summit/REMS0044.jpg';
import img3 from '../../assets/YOCILAB Webiste photos/YOCILAB YOuth Summit/SheLead Circle.jpg';

const day1 = [
  'Morning: Registration, networking breakfast & welcome ceremony',
  'Keynote: Africa\'s Youth Employment Challenge — From Crisis to Opportunity',
  'Career Pathways Panel: Leaders from business, tech, development, creative sectors & public service',
  'Summit Fair Open: Meet exhibitors — employers, educational institutions, organizations, startups',
  'Breakout Sessions 1: Career development, tech innovation, entrepreneurship, leadership, social impact',
  'Lunch & Summit Fair',
  'Workshops 2: Industry deep dives, AI & the future of work, social entrepreneurship, career acceleration',
  'Innovation Challenge Kick-Off: Teams receive their challenge briefs',
  'Evening: Summit Cultural Night — music, storytelling, connection',
];

const day2 = [
  'Morning: Innovation Challenge teams present pitches to judges',
  'Keynote: Building Ventures That Create Jobs',
  'Breakout Sessions 3: Business building, funding & investment, leadership in practice, creative economy',
  'Summit Fair Continues: Employer sessions, recruitment & networking',
  'YOCILAB Fellowship Announcement: 20 Fellows selected',
  'Innovation Challenge Results & Awards',
  'Closing Ceremony: Summit Commitments & Community Pledge',
  'Evening: Summit Social — celebrating 500+ young futures',
];

const zones = [
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/>
      </svg>
    ),
    title: 'Main Stage',
    desc: 'Hear from business executives, entrepreneurs, policymakers, educators, innovators, and young leaders driving change across sectors. Designed to inspire action with practical insights into careers, leadership, and the future of work.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
      </svg>
    ),
    title: 'Opportunity Marketplace',
    desc: 'Brings together employers, universities, scholarship providers, startups, development organizations, and innovation hubs — allowing participants to explore career pathways and programs all in one place.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
      </svg>
    ),
    title: 'Career Studio',
    desc: 'Personalized guidance on CV development, LinkedIn optimization, interview preparation, workplace readiness, and career planning from experienced professionals and recruiters.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
      </svg>
    ),
    title: 'Global Opportunities Hub',
    desc: 'Introduces delegates to scholarships, fellowships, exchange programs, grants, competitions, and international leadership programs with hands-on application guidance.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
    title: 'Networking Lounge',
    desc: 'A relaxed environment where delegates meet employers, mentors, entrepreneurs, investors, speakers, and fellow participants to build lasting relationships.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/>
      </svg>
    ),
    title: 'Employer & Recruitment Corner',
    desc: 'Direct connection with organizations looking for emerging talent. Review CVs, conduct informal interviews, and explore graduate, internship, and full-time roles.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
      </svg>
    ),
    title: 'Future Skills Labs',
    desc: 'Interactive workshops and masterclasses covering AI & digital technology, leadership, communication, personal branding, financial literacy, and project management.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/>
      </svg>
    ),
    title: 'Recognition & Awards',
    desc: 'Celebrating individuals and organizations creating meaningful impact for African youth — from outstanding innovators and educators to mentors and community champions.',
  },
];

const checklist = [
  { title: 'Updated CV / Resume', desc: 'Bring multiple printed copies or a quick QR code link for recruiters at the Employer Corner.' },
  { title: 'Digital Portfolio or Business Cards', desc: 'Showcase your projects, code repositories, design portfolios, or venture summaries.' },
  { title: 'Notebook or Digital Device', desc: 'Take actionable notes during masterclasses, workshops, and keynote sessions.' },
  { title: 'Open Mind & Active Ambition', desc: 'Be ready to ask questions, network boldly, and explore unexpected opportunities.' },
];

const SummitExperience = () => (
  <div className="sub-page">
    <SEO
      title="Summit Experience — YOCILAB Youth Summit 2026"
      description="Two days of keynotes, workshops, employer sessions, and networking at the YOCILAB Youth Summit — 30th and 31st of October 2026, Bamenda, Cameroon."
    />

    {/* HERO */}
    <section className="sub-hero sub-hero--summit">
      <div className="sub-hero__bg">
        <img src={heroImg} alt="Summit Experience" className="sub-hero__img" />
        <div className="sub-hero__overlay" />
      </div>
      <div className="container">
        <div className="sub-hero__content">
          <Link to="/youth-summit" className="sub-hero__back">← Back to Summit</Link>
          <span className="sub-hero__tag">FLAGSHIP EVENT</span>
          <h1 className="sub-hero__title">The Summit Experience</h1>
          <p className="sub-hero__desc">
            Two Days. One Community. Endless Opportunities.
          </p>
          <div className="sub-hero__meta-chips">
            <span className="meta-chip">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              30th &amp; 31st October 2026
            </span>
            <span className="meta-chip">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
              Bamenda, Cameroon
            </span>
            <span className="meta-chip">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/></svg>
              500+ Delegates
            </span>
          </div>
        </div>
      </div>
    </section>

    {/* OVERVIEW */}
    <section className="sub-section">
      <div className="container">
        <div className="sub-two-col">
          <div className="sub-text">
            <span className="section-label">OVERVIEW</span>
            <h2 className="sub-section__title">Two Days. One Community. Endless Opportunities.</h2>
            <p className="sub-body">
              Join over 500 young people from across Cameroon to spark change as we connect talent to opportunities, creating a dignified pathway for youth employment, entrepreneurship, and innovation.
            </p>
            <p className="sub-body">
              Build networks, gain access to global opportunities, and take action on a youth-led platform. The inaugural YOCILAB Youth Summit will take place on <strong>30th &amp; 31st October 2026</strong> in Bamenda, Cameroon.
            </p>
            <div className="sub-actions">
              <Link to="/youth-summit/register" className="sub-btn sub-btn--summit">
                Register to Attend
              </Link>
              <Link to="/contact" className="sub-btn sub-btn--outline-dark">
                Become a Partner
              </Link>
            </div>
          </div>
          <div className="sub-visual">
            <img src={img2} alt="Summit Experience" className="sub-img" loading="lazy" />
          </div>
        </div>
      </div>
    </section>

    {/* WHAT YOU'LL EXPERIENCE - 8 ZONES */}
    <section className="sub-section sub-section--light">
      <div className="container">
        <div className="sub-header">
          <span className="section-label">WHAT YOU'LL EXPERIENCE</span>
          <h2 className="sub-section__title">Eight interactive zones designed for action</h2>
          <p className="sub-section__desc">
            Every corner of the summit is engineered to connect you directly with employers, mentors, knowledge, and funding.
          </p>
        </div>
        <div className="sub-grid-4">
          {zones.map((zone) => (
            <div key={zone.title} className="sub-feature-card">
              <div className="sub-feature-card__icon">{zone.icon}</div>
              <h3 className="sub-feature-card__title">{zone.title}</h3>
              <p className="sub-feature-card__desc">{zone.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* FIND YOUR PLACE */}
    <section className="sub-section">
      <div className="container">
        <div className="sub-header">
          <span className="section-label">FIND YOUR PLACE</span>
          <h2 className="sub-section__title">Tailored tracks for every ecosystem participant</h2>
        </div>
        <div className="sub-grid-4">
          <div className="sub-audience-box">
            <span className="audience-tag">Delegate</span>
            <h3>Young Changemakers</h3>
            <p>Students, graduates, entrepreneurs, and innovators seeking skills, mentorship, and career opportunities.</p>
            <Link to="/youth-summit/register" className="audience-link">Register to Attend →</Link>
          </div>
          <div className="sub-audience-box">
            <span className="audience-tag">Exhibitor</span>
            <h3>Institutions &amp; Hubs</h3>
            <p>Showcase programs, university courses, products, or job openings directly to 500+ motivated delegates.</p>
            <Link to="/youth-summit/register?type=exhibitor" className="audience-link">Book an Exhibition Stand →</Link>
          </div>
          <div className="sub-audience-box">
            <span className="audience-tag">Partner</span>
            <h3>Development Orgs</h3>
            <p>Collaborate with YOCILAB on workshops, recruit top talent, or support the Innovation Challenge.</p>
            <Link to="/contact" className="audience-link">Become a Partner →</Link>
          </div>
          <div className="sub-audience-box">
            <span className="audience-tag">Sponsor</span>
            <h3>Corporates &amp; Donors</h3>
            <p>Position your brand as a champion of youth employability and catalyze high-impact African leadership.</p>
            <Link to="/donate" className="audience-link">Sponsor the Summit →</Link>
          </div>
        </div>
      </div>
    </section>

    {/* SUMMIT SCHOLARSHIPS */}
    <section className="sub-section sub-section--summit-dark">
      <div className="container">
        <div className="sub-two-col">
          <div className="sub-text">
            <span className="section-label section-label--white">ACCESS &amp; INCLUSION</span>
            <h2 className="sub-section__title" style={{ color: '#fff' }}>Summit Scholarships</h2>
            <p className="sub-body" style={{ color: 'rgba(255,255,255,0.85)' }}>
              We believe that financial barriers should never prevent talented young people from accessing life-changing opportunities.
            </p>
            <p className="sub-body" style={{ color: 'rgba(255,255,255,0.85)' }}>
              Through the support of our partners, a limited number of Summit Scholarships will be awarded to outstanding young people demonstrating leadership potential, community impact, innovation, or financial need. Scholarships may cover registration, transportation, accommodation, and meals during the Summit.
            </p>
            <Link to="/youth-summit/register?type=scholarship" className="sub-btn sub-btn--accent">
              Apply for a Summit Scholarship
            </Link>
          </div>
          <div className="sub-text" style={{ background: 'rgba(255,255,255,0.06)', padding: '32px', borderRadius: '20px', border: '1px solid rgba(255,255,255,0.1)' }}>
            <h3 style={{ color: 'var(--color-accent)', marginBottom: '16px' }}>Prepare for Your Summit Experience</h3>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.95rem', marginBottom: '20px' }}>
              To make the most of your time at the Summit, come prepared to engage, learn, and build meaningful relationships:
            </p>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {checklist.map((item) => (
                <li key={item.title} style={{ display: 'flex', gap: '10px', color: 'rgba(255,255,255,0.9)', fontSize: '0.9rem' }}>
                  <span style={{ color: 'var(--color-accent)' }}>✓</span>
                  <div>
                    <strong>{item.title}:</strong> {item.desc}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>

    {/* SCHEDULE */}
    <section className="sub-section">
      <div className="container">
        <div className="sub-header">
          <span className="section-label">PROGRAMME (OUTLINE)</span>
          <h2 className="sub-section__title">Two days. Packed with opportunity.</h2>
        </div>
        <div className="sub-schedule-grid">
          <div className="sub-day-card">
            <div className="sub-day-card__header">
              <span className="sub-day-card__day">Day 1</span>
              <span className="sub-day-card__date">Friday, 30 October 2026</span>
            </div>
            <ul className="sub-day-card__items">
              {day1.map((item, i) => (
                <li key={i} className="sub-day-card__item">
                  <span className="sub-day-card__bullet" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="sub-day-card">
            <div className="sub-day-card__header">
              <span className="sub-day-card__day">Day 2</span>
              <span className="sub-day-card__date">Saturday, 31 October 2026</span>
            </div>
            <ul className="sub-day-card__items">
              {day2.map((item, i) => (
                <li key={i} className="sub-day-card__item">
                  <span className="sub-day-card__bullet" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>

    {/* REGISTER CTA */}
    <section className="sub-cta-section">
      <div className="container">
        <div className="sub-cta-block fade-up">
          <img src={img3} alt="Summit delegates" className="sub-cta-block__img" loading="lazy" />
          <div className="sub-cta-block__content">
            <h2 className="sub-cta-block__title">Your seat is waiting.</h2>
            <p className="sub-cta-block__desc">
              Spaces are limited. Register early to secure your place at Cameroon's leading youth platform on 30th &amp; 31st October 2026.
            </p>
            <Link to="/youth-summit/register" className="sub-btn sub-btn--summit">
              Register as a Delegate →
            </Link>
          </div>
        </div>
      </div>
    </section>

    {/* NAV STRIP */}
    <section className="sub-nav-strip summit-nav-strip">
      <div className="container">
        <h3 className="sub-nav-strip__title">Explore More Summit Experiences</h3>
        <div className="sub-nav-strip__grid">
          <Link to="/youth-summit/campus-tour" className="sub-nav-card">
            <span className="sub-nav-card__label">Before</span>
            <span className="sub-nav-card__title">← Campus Tour</span>
          </Link>
          <Link to="/youth-summit/innovation-challenge" className="sub-nav-card">
            <span className="sub-nav-card__label">Also at Summit</span>
            <span className="sub-nav-card__title">Innovation Challenge →</span>
          </Link>
          <Link to="/youth-summit/fellowship" className="sub-nav-card">
            <span className="sub-nav-card__label">After the Summit</span>
            <span className="sub-nav-card__title">YOCILAB Fellowship →</span>
          </Link>
        </div>
      </div>
    </section>
  </div>
);

export default SummitExperience;
